import Vue from 'vue'
import Vuex from 'vuex'
import common from './modules/common'
import system from './modules/system'
import order from './modules/order'
import stock from './modules/stock'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    common,
    system,
    order,
    stock
  }
})
